import React from 'react';
import { splitFlowContextParts } from '../../utils/catalogFlowCourse';

type FlowContextBreadcrumbProps = {
  contextSubtitle: string;
  isRtl: boolean;
  contextSubtitleFa?: string | null;
  className?: string;
};

/** LTR-isolated `<` so Unicode bidi does not mirror it to `>` in RTL paragraphs. */
const RtlPathSeparator: React.FC = () => (
  <span dir="ltr" className="inline-block select-none opacity-75" aria-hidden>
    {' < '}
  </span>
);

/** Course / level / lesson path under quiz and exercise titles — RTL-aware in fa mode. */
export const FlowContextBreadcrumb: React.FC<FlowContextBreadcrumbProps> = ({
  contextSubtitle,
  isRtl,
  contextSubtitleFa,
  className = 'mt-0.5 block w-full text-xs text-gray-500 dark:text-gray-400',
}) => {
  const parts = splitFlowContextParts(contextSubtitle, isRtl, contextSubtitleFa);
  if (parts.length === 0) return null;

  if (!isRtl) {
    return <p className={className}>{parts.join(' › ')}</p>;
  }

  return (
    <p className={className} dir="rtl">
      <span className="inline-flex w-full flex-wrap items-center justify-start gap-x-0.5">
        {parts.map((part, index) => (
          <React.Fragment key={`${index}-${part}`}>
            {index > 0 ? <RtlPathSeparator /> : null}
            <span>{part}</span>
          </React.Fragment>
        ))}
      </span>
    </p>
  );
};
